define('native/NativeLayerMessenger',[],function () {

    return function (LOG) {

        this.sendMessage = function (name, message, onError) {

            if (!window.native) {
                return;
            }

            try {
                console.log('Sending message to native layer on channel "' + name + '"', message);
                window.webkit.messageHandlers[name].postMessage(message || '');

            } catch (error) {

                LOG.error(error);
                if (onError) {
                    onError(error);
                }
            }
        };
    };
});

